import React, { useEffect } from 'react';
import {
  Divider,
  List,
  ListItemText,
  ListSubheader,
  ListItemIcon,
  Box,
  CircularProgress,
  ListItem,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux/';
import useStyles from './styles';
import { useGetGenreQuery } from '../../services.js/TMDB';
import genreIcons from '../../assets/genres';
import { selectGenreOrCategory } from '../../features/currentGenreOrCategory';
// const demoCategories = ['Comdey', 'Action', 'Horror', 'Animation'];
const categories = [
  {
    label: 'Popular', value: 'popular',
  }, {
    label: 'Top Rated', value: 'top_rated',
  }, {
    label: 'Upcoming', value: 'upcoming',
  },
];

const redLogo = 'https://fontmeme.com/permalink/220725/bd0f0140b7e7718e2406bcc3375b12eb.png';
const whiteLogo = 'https://fontmeme.com/permalink/220725/bd0f0140b7e7718e2406bcc3375b12eb.png';
const Sidebar = ({ setMobileOpen }) => {
  const { genreIdOrCategoryName } = useSelector((state) => state.currentGenreOrCategory);
  const theme = useTheme();
  const classes = useStyles();
  const { data, isFetching } = useGetGenreQuery();
  const dispatch = useDispatch();
  console.log(data);
  useEffect(() => {
    setMobileOpen(false);
  }, [genreIdOrCategoryName]);
  return (
    <>
      <Link to="/" className={classes.imageLink}>
        <img className={classes.img} src={theme.palette.mode === redLogo ? whiteLogo : redLogo} alt="LIKEWISE logo" />
      </Link>
      <Divider />
      <List>
        <ListSubheader>Categories</ListSubheader>
        {categories.map(({ label, value }) => (
          <Link key={value} className={classes.links} to="/">
            <ListItem onClick={() => dispatch(selectGenreOrCategory(value))} button>
              <ListItemIcon>
                <img src={genreIcons[label.toLowerCase()]} className={classes.genreImage} height={30} />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          </Link>
        ))}
      </List>
      <Divider />
      <List>
        <ListSubheader>Genres</ListSubheader>

        {isFetching ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : data.genres.map(({ name, id }) => (
          <Link key={name} className={classes.links} to="/">
            <ListItem onClick={() => dispatch(selectGenreOrCategory(id))} button>
              <ListItemIcon>
                <img src={genreIcons[name.toLowerCase()]} className={classes.genreImage} height={30} />
              </ListItemIcon>
              <ListItemText primary={name} />
            </ListItem>
          </Link>
        ))}
      </List>
      <Divider />

    </>
  );
};

export default Sidebar;
